export default function getTierFromPrice(price) {
  switch (price) {
    case 10:
      return 'Tier 1';
    case 50:
      return 'Tier 2';
    case 250:
      return 'Tier 3';
    default:
      return 'Unable to obtain tier information';
  }
}
